import React from 'react'
import { Icon, Button, Header, Form, Modal, Checkbox } from 'semantic-ui-react'
import moment from 'moment'

import firebase from 'firebase/app'
import _ from 'lodash'

import BranchField from '../../fields/branchField'
import UnavailableItemField from './unavailableItemField'

class UnavailableItemForm extends React.PureComponent {
  btnSubmitRef = React.createRef()

  state = {
    loading: false,
    selectedItems: [],
    selectedBranch: null,
    isApplyToAllBranches: false,
    removedItems: [],
  }

  componentDidMount() {
    const { action } = this.props

    if (action === 'edit') {
      this.getUnavailableItemData()
    } else {
      this.setState({ selectedItems: [{}]})
    }
  }

  getUnavailableItemData = () => {
    const { unavailableBranch } = this.props

    const unavailableItems = _.map(unavailableBranch, item => ({
      itemKey: item.item_id,
      startedAt: item.started_at,
      endedAt: item.ended_at,
      docId: item.doc_id,
    }))

    this.setState({
      selectedItems: unavailableItems,
      selectedBranch: unavailableBranch[0].branch_id,
    })
  }

  setStateAsync = state => new Promise(resolve => this.setState(state, resolve))

  saveToAllBranches = async() => {
    const { selectedItems } = this.state
    const { storeId, allBranches } = this.props

    const batch = firebase.firestore().batch()

    _.forEach(allBranches.noUnavailableItemBranches, branch => {

      _.forEach(selectedItems, item => {
        const doc =  firebase.firestore().collection('unavailable_items').doc()
        const { startedAt, endedAt, itemKey } = item

        const updates = {
          branch_id: branch.key,
          merchant_id: storeId,
          item_id: itemKey,
          started_at: Number(moment(startedAt).startOf('day').format('x')),
          ended_at: Number(moment(endedAt).endOf('day').format('x')),
        }

        batch.set(doc, updates)
      })
    })

    await batch.commit()
  }

  upsertUnavailableItem = async() => {
    const { selectedItems, selectedBranch, removedItems } = this.state
    const { storeId } = this.props

    const validRemovedItems = removedItems.filter(item => item !== undefined)

    const batch = firebase.firestore().batch()

    if (validRemovedItems) {
      _.forEach(validRemovedItems, docKey => {
        const ref = firebase.firestore().collection('unavailable_items').doc(docKey)

        batch.delete(ref)
      })
    }

    _.forEach(selectedItems, item => {
      const { startedAt, endedAt, itemKey } = item

      const collection = firebase.firestore().collection('unavailable_items')

      const doc =  item.docId ? collection.doc(item.docId) : collection.doc()

      const updates = {
        merchant_id: storeId,
        branch_id: selectedBranch,
        item_id: itemKey,
        started_at: Number(moment(startedAt).startOf('day').format('x')),
        ended_at: Number(moment(endedAt).endOf('day').format('x')),
      }

      batch.set(doc, updates)
    })

    await batch.commit()
  }

  onSave = async e => {
    e.preventDefault()

    const { isApplyToAllBranches } = this.state
    const { onClose, storeId, getUnavailableItems } = this.props

    const isEmptyField = this.validateEmptyField()
    if (!isEmptyField) return false

    await this.setStateAsync({ loading: true })

    if (isApplyToAllBranches) {
      this.saveToAllBranches()
    } else {
      this.upsertUnavailableItem()
    }

    await this.setStateAsync({ loading: false })
    getUnavailableItems(storeId)
    onClose()

    return true
  }

  validateEmptyField = () => {
    const { selectedBranch, selectedItems, isApplyToAllBranches } = this.state

    const selectedItemKeys = _.map(selectedItems, item => item.itemKey)
    const isHasUndefinedField = _.map(selectedItems, item => (
      !item.itemKey || !item.startedAt || !item.endedAt
    )).includes(true)

    if (!isApplyToAllBranches && selectedBranch === null) {
      alert('Please select restaurant branch')
      return false
    }

    if (isHasUndefinedField) {
      alert('Please check the blank field')
      return false
    }

    if (this.checkForDuplicateItems(selectedItemKeys)) {
      alert('Cannot add duplicate items')
      return false
    }

    return true
  }

  checkForDuplicateItems = items => {
    const valuesAlreadySeen = []

    for (let i = 0; i < items.length; i+= 1) {
      const value = items[i]
      if (valuesAlreadySeen.indexOf(value) !== -1) {
        return true
      }
      valuesAlreadySeen.push(value)
    }
    return false
  }

  onAddMoreClick = () => {
    const { selectedItems } = this.state

    this.setState({ selectedItems: selectedItems.concat({}) })
  }

  onUnavailableFieldChange = (data, index) => {
    const { selectedItems } = this.state

    const selectedItemArr = Array.from(selectedItems)
    selectedItemArr[Number(index)] = data

    this.setState({ selectedItems: selectedItemArr })
  }

  onItemRemove = (index, docId) => {
    const { selectedItems, removedItems } = this.state

    this.setState({
      selectedItems: selectedItems.filter((item, itemIndex) => index !== itemIndex),
      removedItems: removedItems.concat(docId)
    })
  }

  render() {
    const {
      loading,
      selectedItems,
      selectedBranch,
      isApplyToAllBranches,
    } = this.state

    const { visible, onClose, allBranches, items, action } = this.props

    return (
      <Modal open={visible} size="large" style={{ marginTop: 0 }}>
        <Header content="Add Item Unavailable" />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form onSubmit={this.onSave} disabled={loading}>
            <Form.Group widths="equal">
              <BranchField
                value={selectedBranch}
                branches={action === 'edit' ? allBranches.allBranches : allBranches.noUnavailableItemBranches}
                onChange={value => this.setState({ selectedBranch: value })}
                disabled={action === 'edit'}
              />
            </Form.Group>

            {
              _.map(selectedItems, (item, index) => {
                return (
                  <UnavailableItemField
                    item={item}
                    key={index}
                    allItems={items}
                    onRemove={() => this.onItemRemove(index, item.docId)}
                    onChange={data => this.onUnavailableFieldChange(data, index)}
                  />
                )
              })
            }

            <Button
              as='div'
              onClick={this.onAddMoreClick}
              color="black"
              floated="right"
            >
              Add More
            </Button>

            {action === 'create' ? (
              <Form.Group widths="equal" style={{ marginLeft: 5, marginTop: 20 }}>
                <Checkbox
                  label="Apply to all branches"
                  checked={isApplyToAllBranches}
                  onChange={() => this.setState({ isApplyToAllBranches: !isApplyToAllBranches })}
                />
              </Form.Group>
            ) : null}

            <button
              type="submit"
              hidden
              ref={ref => { this.btnSubmitRef = ref }}
            />
          </Form>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={loading}
            disabled={loading}
          >
            <Icon name="checkmark" /> {action === 'create' ? 'Save' : 'Update'}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default UnavailableItemForm



// WEBPACK FOOTER //
// ./src/components/restaurants/forms/unavailableItemForm/index.js